/* global axios */
import ApiClient from '../ApiClient';

const buildCreatePayload = ({ content, files }) => {
  if (files && files.length) {
    const payload = new FormData();
    if (content) payload.append('content', content);
    files.forEach(file => payload.append('attachments[]', file));
    return payload;
  }
  return { content };
};

class InternalMessages extends ApiClient {
  constructor() {
    super('internal/rooms', { accountScoped: true });
  }

  get(roomId, params = {}) {
    return axios.get(`${this.url}/${roomId}/messages`, { params });
  }

  create(roomId, { content, files }) {
    const data = buildCreatePayload({ content, files });
    const config =
      data instanceof FormData
        ? { headers: { 'Content-Type': 'multipart/form-data' } }
        : {};
    return axios.post(`${this.url}/${roomId}/messages`, data, config);
  }
}

export default new InternalMessages();
